import { type OpenApiSchemaImportStocksSettings } from '../../api/schema';
import { INTEGRATION_TYPE_YANDEX_MARKET_LAAS } from './constants';

export function checkChosenYandexLaasLogisticIntegrationSubType(
    subTypes: OpenApiSchemaImportStocksSettings['sub_types']
) {
    return (
        subTypes !== undefined && subTypes.some((subType) => subType.sub_type === INTEGRATION_TYPE_YANDEX_MARKET_LAAS)
    );
}
